class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.openTimeout = null;
    this.closeTimeout = null;
    this.isDesktop = window.matchMedia('(min-width: 990px)');
    this.setupDesktopHover();
  }

  setupDesktopHover() {
    // Hover intent: delay open so passing over items briefly doesn't trigger
    this.addEventListener('mouseenter', () => {
      if (!this.isDesktop.matches) return;
      clearTimeout(this.closeTimeout);
      this.openTimeout = setTimeout(() => this.open(), 200);
    });

    this.addEventListener('mouseleave', () => {
      if (!this.isDesktop.matches) return;
      clearTimeout(this.openTimeout);
      this.closeTimeout = setTimeout(() => this.close(), 300);
    });

    // Keep mega menu open while cursor is inside the dropdown content
    const megaContent = this.querySelector('.mega-menu__content');
    if (megaContent) {
      megaContent.addEventListener('mouseenter', () => {
        if (!this.isDesktop.matches) return;
        clearTimeout(this.closeTimeout);
        clearTimeout(this.openTimeout);
      });
      megaContent.addEventListener('mouseleave', () => {
        if (!this.isDesktop.matches) return;
        this.closeTimeout = setTimeout(() => this.close(), 250);
      });
    }
  }

  open() {
    // Close any other open header menus first
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle.hasAttribute('open')) {
        menu.close();
      }
    });
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
